import React from "react";
import logo from "./../../assets/Logo.jpg";

function BluestacksLogo({ ...props }) {
  return <img src={logo} alt="bluestacks logo" {...props} />;
}

export default BluestacksLogo;
